import React, {useEffect, useState} from 'react';
import {Dialog, DialogContent, DialogTitle} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";


export interface IContactDataProps {
  dialogTriggerQuery: string,
}

const ContactData = (props: IContactDataProps) => {

  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    const button = props.dialogTriggerQuery ? document.querySelector(props.dialogTriggerQuery) : null;

    if (button) {
      button.addEventListener('click', () => {
        setOpen(true);
      });
    }

  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>Ihr Kontakt zu uns</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <div className="md:flex md:justify-between">
            <div className="max-w-[200px] rounded mr-8 overflow-hidden">
              <img className=""
                   src="https://www.dr-heiko-hofer.de/drimage/1020/1020/88/-/jpg?q=drimage/620/620/88/-/sites/drhhofer/files/styles/drimage_1024_/public/2025-02/img_2834.jpg&amp;itok=4Ito_CB9"/>
            </div>
            <div>
              <div className="mt-4 font-bold">
                Büttner Ergotherapie
              </div>
              <div>
                <p className="mb-3"><br/>
                  Am Krankenhaus 1a, 21614 Buxtehude</p>
                <ul>
                  <li className="flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                         viewBox="0 0 24 24" stroke-width="1.5"
                         stroke="currentColor" className="w-5 h-5 mr-2">
                      <path stroke-linecap="round" stroke-linejoin="round"
                            d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3"></path>
                    </svg>
                    <a href="tel:04161 76 88 70">04161 76 88 70</a>
                  </li>
                  <li className="flex items-center mt-3">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none"
                         viewBox="0 0 24 24" stroke-width="1.5"
                         stroke="currentColor" className="w-5 h-5 mr-2">
                      <path stroke-linecap="round" stroke-linejoin="round"
                            d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"></path>
                    </svg>
                    <a href="mailto:empfang@ergo-buettner.de"
                       className="hover:underline  ">empfang@ergo-buettner.de</a>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ContactData;
